import { addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { SectionDetail } from '../../../../types/sectionMaintainerTypes';
import { useNonStructuredFormDataLoader } from '../../loaders/NonStructuredLoader';
import { updateNonStructuredSectionActionRequest } from '../api';
import {
  useNonStructuredSectionLoader,
  useNonStructuredSectionLoaderData,
} from '../hooks/NonStructuredSectionLoader';
import { NonStructuredSectionForm } from './NonStructuredSectionForm';

const SectionGeneralTab = () => {
  const { t } = useTranslation();
  const sectionData = useNonStructuredSectionLoaderData();
  const { refresh } = useNonStructuredSectionLoader();
  const { result: formDataResult } = useNonStructuredFormDataLoader();

  const formData = formDataResult?.success ? formDataResult.data : null;

  if (!sectionData || !formData) {
    return null;
  }

  const section = (sectionData.section as unknown) as SectionDetail;

  return (
    <div className="mt-2 mx-3">
      <NonStructuredSectionForm
        section={section}
        campuses={formData.campuses}
        schedules={formData.schedules}
        deliveryMode={sectionData.section.course.modality?.deliveryMode}
        onSave={async (values) => {
          const { data, error } = await updateNonStructuredSectionActionRequest(
            section.id,
            {
              name: `${values.code}-${values.name}`,
              maximumStudent: Number(values.quota),
              campusId: Number(values.campus.value),
              scheduleId: Number(values.schedule.value),
              professors: values.teachers.filter((item) => !!item.value),
              assistants: values.assistants.filter((item) => !!item.value),
              onlineAssistanceRequirement: section.onlineAssistanceRequirement,
              assistanceRequirements: section.assistanceRequirements
                ? section.assistanceRequirements.map((r) => ({
                    ...r,
                    minPercentage: Number(r.minPercentage),
                  }))
                : [],
            },
          );

          if (data && !error) {
            addToast({
              icon: 'success',
              color: 'success',
              text: t('common.messages.editSuccess'),
            });
            refresh();
          } else {
            const errorMessage = (error as any)?.data?.message;
            if (errorMessage === 'SECTION_NAME_ALREADY_EXISTS') {
              addToast({
                icon: 'error',
                color: 'danger',
                text: t(
                  'sectionsMaintainer.create.sectionNameAlreadyExistsError',
                ),
              });
            } else {
              addToast({
                icon: 'error',
                color: 'danger',
                text: t('common.errors.save'),
              });
            }
          }
        }}
      />
    </div>
  );
};

export default SectionGeneralTab;
